import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "epoch__content moment" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "timeline-window__media site-page-partial__no-image-container"
}
const _hoisted_5 = {
  key: 0,
  class: "window-top"
}
const _hoisted_6 = {
  key: 1,
  class: "window-bottom"
}
const _hoisted_7 = { class: "moment__header" }
const _hoisted_8 = { class: "moment__excerpt" }

import { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";
import { useElementInViewportService } from "../../services/jvm/elementInViewportService";
import { onMounted } from "vue";
import { useTimelineMapStore } from "../../store/timelineMapStore";
import { useTimelineMapService } from "../../services/timelineMapService";



export default /*@__PURE__*/_defineComponent({
  __name: 'MomentJVM',
  props: {
    moment: {}
  },
  setup(__props: any) {

const { trimWindowTypes } = useTimelineMapService();
const store = useTimelineMapStore();
const props = __props
const trimmedWindowType = trimWindowTypes(props.moment.windowType);

const showModal = () => {
  store.onShowModal(props.moment);
}

onMounted(() => {
  useElementInViewportService('timeline', props.moment.urlSegment, !!props.moment.urlSegment);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    id: __props.moment.urlSegment,
    class: _normalizeClass(['epoch__item', 'epoch__item--moment', __props.moment.illustration, `epoch__item--${_unref(trimmedWindowType)}`])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['timeline-window', __props.moment.windowType])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['timeline-window__view', __props.moment.view])
        }, [
          (__props.moment.imageHtml)
            ? (_openBlock(), _createElementBlock("figure", {
                key: 0,
                class: "timeline-window__media",
                innerHTML: __props.moment.imageHtml
              }, null, 8 /* PROPS */, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "site-page-partial__no-image-container-graphic" }, null, -1 /* CACHED */)
              ]))])),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "image-overlay" }, null, -1 /* CACHED */))
        ], 2 /* CLASS */),
        (__props.moment.windowType == 'timeline-window--early-1900')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("v-if", true),
        (__props.moment.windowType == 'timeline-window--early-1900')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h2", null, _toDisplayString(__props.moment.year), 1 /* TEXT */),
        _createElementVNode("div", null, _toDisplayString(__props.moment.title), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.moment.momentExcerpt), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "moment__button",
        onClick: _withModifiers(showModal, ["prevent"])
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "sr-only" }, "Open more information", -1 /* CACHED */)
      ]))])
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})